<template>
  <section id="all-projects" class="all-projects-page">
    <div class="container">
      <div class="page-header">
        <a href="/" class="back-link">
          <font-awesome-icon icon="chevron-left" /> Back to Home
        </a>
        <h1 class="page-title">All Projects</h1>
      </div>

      <div class="projects-grid">
        <div
          class="project-card"
          v-for="project in projects"
          :key="project.title"
          @click="openProject(project.demo)"
        >
          <div class="project-content">
            <h3 class="project-title">{{ project.title }}</h3>
            <p class="project-description">{{ project.description }}</p>
            <div class="project-domain">
              <span class="domain-text"> <font-awesome-icon icon="external-link-alt" class="h-3 w-3" />  {{  project.domain }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AllProjectsPage",
  mounted() {
    document.title = "Jayson Gomba - Projects";
  },
  beforeUnmount() {
    document.title = "Jayson Gomba";
  },
  data() {
    return {
      projects: [
        {
          title: "Bantay Panahon",
          description: "A comprehensive Filipino weather application providing reliable and easy-to-understand weather information.",
          domain: "bantaypanahon.vercel.app",
          demo: "https://bantaypanahon.vercel.app",
        },
        {
          title: "Placehub Rental System",
          description: "A comprehensive apartment rental platform with user authentication",
          domain: "placehub.bsit3a2025.com",
          demo: "https://placehub.bsit3a2025.com",
        },
        {
          title: "Procurease (Procurement Management System)",
          description: "A full-stack procurement management system designed to modernize and centralize institutional purchasing and financial workflows.",
          domain: "procurease.bsit3a2025.com",
          demo: "https://procurease.bsit3a2025.com/",
        },
        {
          title: "OCR Receipt",
          description: "a web-based platform designed to streamline the management of reimbursements, billing, and receipt processing for employees, HR, and administrators.",
        },
        {
          title: "ACCESS Organization",
          description: "Modern website for the ACCESS organization",
          domain: "access-department-theta.vercel.app",
          demo: "https://access-department-theta.vercel.app",
        },
      ],
    };
  },
  methods: {
    openProject(url) {
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  },
};
</script>

<style scoped>
.all-projects-page {
  min-height: 100vh;
  padding: 20px 320px;
  background-color: var(--bg-primary);
}

.page-header {
  margin-bottom: 2rem;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: var(--primary-color);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.project-card {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--border-radius);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1.5px solid hsl(var(--foreground) / 0.28);
  cursor: pointer;
  color: hsl(var(--foreground));
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;   
}

:global([data-theme="light"]) .project-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.project-card::before {
  content: "";
  position: absolute;
  pointer-events: none;
  border-radius: var(--border-radius);
}

:global([data-theme="light"]) .project-card::before {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.project-card:hover {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

:global([data-theme="light"]) .project-card:hover {
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
}

.project-content {
  padding: 1.25rem 1rem;
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.project-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  line-height: 1.3;
}

.project-description {
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
  margin-bottom: 1rem;
  opacity: 0.85;
  flex: 1;
}

.project-domain {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: auto;
}

.domain-text {
  font-family: 'Courier New', monospace;
  opacity: 0.9;
}

@media (max-width: 992px) {
  .projects-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 768px) {
  .all-projects-page {
    padding: 24px 16px;
  }

  .page-header {
    margin-bottom: 1.25rem;
  }

  .back-link {
    margin-bottom: 0.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .project-content {
    padding: 1.25rem;
  }

  .project-title {
    font-size: 1rem;
  }

  .project-description {
    font-size: 0.8rem;
  }

  .project-domain {
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .project-content {
    padding: 1rem;
  }
}
</style>
